import React, { useEffect, useState } from 'react';

import { jsPDF } from 'jspdf';
import 'jspdf-autotable';

import dateFormat from 'dateformat';
import { toast } from 'react-toastify';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import { addLocale } from 'primereact/api';
import { Input155px } from '../../../styles/inputGroup';
import Card from '../../../components/card';
import Loading from '../../loading';

import store from '../../../store/store';
import axiosAdmin from '../../../services/axiosAdmin';
import { formataMoeda } from '../../../util/diversos';

export default function RelatorioRecebimento() {
  const [isLoading, setIsLoading] = useState(false);
  const [findDataInicial, setFindDataInicial] = useState(null);
  const [findDataFinal, setFindDataFinal] = useState(null);
  const [findSituacao, setFindSituacao] = useState('TODOS');

  const [listaSituacao] = useState([
    { label: 'Todos', value: 'TODOS' },
    { label: 'Abertos', value: 'ABERTO' },
    { label: 'Quitados', value: 'QUITADO' },
  ]);

  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: 99999,
    page: 0,
    sortField: null,
    sortOrder: null,
    filters: null,
  });

  addLocale('pt-BR', {
    firstDayOfWeek: 0,
    dayNames: ['domingo', 'segunda', 'terça', 'quarta', 'quinta', 'sexta', 'sábado'],
    dayNamesShort: ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'],
    dayNamesMin: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
    monthNames: ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'],
    monthNamesShort: ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'],
    today: 'hoje',
    clear: 'Limpar',
  });

  function headRows() {
    return [
      { id: 'id', dataVencimento: 'Vencimento', nomeFantasia: 'Empresa', valorAberto: 'Em aberto', valorPago: 'Pago', dataQuitacao: 'Quitação' },
    ];
  }

  function headRowsQuitados() {
    return [
      { id: 'id', dataVencimento: 'Vencimento', nomeFantasia: 'Empresa', valorPago: 'Pago', dataQuitacao: 'Quitação' },
    ];
  }

  function headRowsAbertos() {
    return [
      { id: 'id', dataVencimento: 'Vencimento', nomeFantasia: 'Empresa', valorAberto: 'Valor em Aberto' },
    ];
  }

  const [headerTabelaImpressao, setHeaderTabelaImpressao] = useState(headRows());

  useEffect(() => {
    if (findSituacao === 'TODOS') {
      setHeaderTabelaImpressao(headRows());
    }
    if (findSituacao === 'ABERTO') {
      setHeaderTabelaImpressao(headRowsAbertos());
    }
    if (findSituacao === 'QUITADO') {
      setHeaderTabelaImpressao(headRowsQuitados());
    }

    console.log('headerTabelaImpressao', headerTabelaImpressao);
  }, [findSituacao]);

  async function getData(searchFilter, page, size) {
    // eslint-disable-next-line new-cap
    const doc = new jsPDF();
    try {
      setIsLoading(true);

      if (findDataInicial == null && findDataFinal == null) {
        toast.info('Datas devem ser informadas.');
        return;
      }

      if (findDataInicial > findDataFinal) {
        toast.info('Data final anterior a data inicial.');
        return;
      }

      let params = '/elorecebimento/search';

      if (searchFilter && searchFilter.findDataInicial !== '') {
        const _dataInicial = `${dateFormat(searchFilter.findDataInicial, 'dd-mm-yyyy')}`;
        const _dataFinal = `${dateFormat(searchFilter.findDataFinal, 'dd-mm-yyyy')}`;

        params = `${params}?dataVencimentoInicial=${_dataInicial}&dataVencimentoFinal=${_dataFinal}`;
      }

      if (searchFilter && searchFilter.findSituacao) {
        params = `${params}&situacao=${searchFilter.findSituacao}`;
      }

      params = `${params}&page=${page}&size=${size}`;

      const response = await axiosAdmin.get(params);

      if (response.data.content.length <= 0) {
        toast.info('Não há registros a serem exibidos.');
        return;
      }

      let data = {
        id: '0',
        dataVencimento: '',
        dataQuitacao: '',
        nomeFantasia: '',
        valorAberto: '',
        valorPago: '',
      };

      const result = [];
      let totalAberto = 0;
      let totalPago = 0;
      for (let x = 0; x < response.data.content.length; x++) {
        const recebimento = response.data.content[x];

        data.id = recebimento.id.toString();

        const dataVencimento = `${('00' + recebimento.dataVencimento[2]).slice(-2)}/${('00' + recebimento.dataVencimento[1]).slice(-2)}/${recebimento.dataVencimento[0]}`;
        data.dataVencimento = dataVencimento;

        if (recebimento.dataQuitacao) {
          const dataQuitacao = `${('00' + recebimento.dataQuitacao[2]).slice(-2)}/${('00' + recebimento.dataQuitacao[1]).slice(-2)}/${recebimento.dataQuitacao[0]}`;
          data.dataQuitacao = dataQuitacao;
        }

        data.nomeFantasia = recebimento.empresa.nomeFantasia;

        if (recebimento.valorAberto > 0) {
          totalAberto += recebimento.valorAberto;
        }
        data.valorAberto = formataMoeda(recebimento.valorAberto);

        if (recebimento.valorPago > 0) {
          totalPago += recebimento.valorPago;
        }
        data.valorPago = formataMoeda(recebimento.valorPago);

        result.push({ ...data });
      }

      data = {
        id: '',
        dataVencimento: '',
        dataQuitacao: '',
        nomeFantasia: '',
        valorAberto: '',
        valorPago: '',
      };

      result.push({ ...data });

      data = {
        id: '',
        dataVencimento: '',
        dataQuitacao: '',
        nomeFantasia: '',
        valorAberto: formataMoeda(totalAberto),
        valorPago: formataMoeda(totalPago),
      };

      result.push({ ...data });

      doc.autoTable({
        styles: {
          fontSize: 8,
        },
        margin: { top: 38, left: 5, right: 5 },
        columnStyles: {
          0: { cellWidth: 15 },
        },
        theme: 'grid',
        head: headerTabelaImpressao,
        body: result,
        didDrawPage: dados => {
          // Header
          doc.rect(5, 5, 200, 30);
          // doc.addImage(img, 'JPEG', 9, 8, 25, 25);
          doc.setFontSize(20);
          doc.text('Relatório de Recebimentos ', 65, 15);

           doc.setFontSize(10);
          doc.text('Situação:', 15, 32);
          doc.text(findSituacao, 31, 32);


          doc.text('Período:', 135, 32);
          doc.text(`${dateFormat(findDataInicial, 'dd/mm/yyyy')}`, 150, 32);
          doc.text(' à ', 169, 32);
          doc.text(`${dateFormat(findDataFinal, 'dd/mm/yyyy')}`, 174, 32);


          /*
          doc.setFontSize(8);
          doc.text('Período:', 50, 32);
          doc.text(dateFormat(findDataInicial, 'dd/mm/yyyy'), 63, 32);
          doc.text(' à ', 79, 32);
          doc.text(dateFormat(findDataFinal, 'dd/mm/yyyy'), 83, 32);
          */

          // colocar a empresa destino se houver

          // footer
          const { pageSize } = doc.internal;
          const pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
          doc.text(`Pag ${doc.internal.getNumberOfPages()}`, dados.settings.margin.right, pageHeight - 8);
          doc.text('Elo Informática Barbacena LTDA', 82, pageHeight - 8);
          const periodo = new Date();
          doc.text('Impresso: ', 172, pageHeight - 8);
          // eslint-disable-next-line prefer-template
          doc.text((`${('00' + periodo.getDate()).slice(-2)}/${('00' + (+periodo.getMonth() + 1)).slice(-2)}/${periodo.getFullYear()}`).toString(), 189, pageHeight - 8);
        },
      });
      window.open(doc.output('bloburl'));
    } catch (e) {
      // console.log(e);
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    const today = new Date();
    const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    setFindDataInicial(firstDayOfMonth);
    setFindDataFinal(new Date(store.getState().auth.consultaEstampariaPedidoDataFinal));
  }, []);

  const handleFind = () => {
    const searchFilter = { findDataInicial, findDataFinal, findSituacao };

    const _lazyParams = { ...lazyParams, first: 0, page: 0 };

    setLazyParams(_lazyParams);

    getData(searchFilter, 0, lazyParams.rows);
  };

  return (
    <>
      <Loading isLoading={isLoading} />

      <Card>
        <div className="card mb-43">
          <h6 className="card-header" style={{ textAlign: 'center' }}> Relatório de Recebimentos </h6>
        </div>
        <div className="row form-elo">
          <div className="col-lg-3">
            <div className="p-inputgroup">
              <Input155px className="p-inputgroup-addon">
                Data inicial
              </Input155px>
              <Calendar
                id="mask"
                showIcon
                mask="99/99/9999"
                dateFormat="dd/mm/yy"
                showButtonBar
                showOnFocus={false}
                locale="pt-BR"
                value={findDataInicial}
                onChange={(e) => setFindDataInicial(e.value)}
              />
            </div>
          </div>
          <div className="col-lg-3">
            <div className="p-inputgroup">
              <Input155px className="p-inputgroup-addon">
                Data final
              </Input155px>
              <Calendar
                id="mask"
                showIcon
                mask="99/99/9999"
                dateFormat="dd/mm/yy"
                showButtonBar
                showOnFocus={false}
                locale="pt-BR"
                value={findDataFinal}
                onChange={(e) => setFindDataFinal(e.value)}
              />
            </div>
          </div>
          <div className="col-lg-3">
            <div className="p-inputgroup">
              <Input155px className="p-inputgroup-addon">
                Situacao
              </Input155px>
              <Dropdown
                options={listaSituacao}
                value={findSituacao}
                emptyMessage="Nenhum registro a ser exibido"
                onChange={(e) => setFindSituacao(e.target.value)}
              />
            </div>
          </div>
          <div className="col-lg-1 text-end">
            <button
              type="button"
              title="Imprimir Relatório"
              className="btn btn-success"
              style={{ borderRadius: '15px' }}
              onClick={handleFind}
            >
              <i className="pi pi-print"></i>
            </button>
          </div>
        </div>
      </Card>
    </>
  );
}
